<ng-container *ngIf="employment$ | async as employment">
  <div
    class="employment-list-item"
    [class.status-available]="
      (ownStatus$ | async) === EmploymentInviteeStatusEnum.AVAILABLE
    "
    [class.status-unavailable]="
      (ownStatus$ | async) === EmploymentInviteeStatusEnum.UNAVAILABLE
    "
    [class.status-declined]="
      (ownStatus$ | async) === EmploymentInviteeStatusEnum.DECLINED
    "
    [class.status-booked]="
      (ownStatus$ | async) === EmploymentInviteeStatusEnum.BOOKED
    "
    [class.status-open]="
      (ownStatus$ | async) === EmploymentInviteeStatusEnum.OPEN
    "
    [attr.data-cy]="'employment-list-item-' + employment._id">
    <div class="header-meta">
      <app-employment-date [employment]="employment"></app-employment-date>
    </div>
    <app-employment-organisation-heading
      class="employment-heading"
      [employment]="employment"></app-employment-organisation-heading>
    <app-pooler-employment-details-table
      class="details-table"
      [customer]="(eligibleCustomers$ | async)?.[0]"
      [employment]="employment"></app-pooler-employment-details-table>
    <div class="employment-footer">
      <div class="start-items"></div>
      <div class="end-items">
        <ng-container
          *ngIf="
            (ownStatus$ | async) === EmploymentInviteeStatusEnum.OPEN &&
              employment?.status === EmploymentStatusEnum.OPEN;
            else responseTemplate
          ">
          <button
            class="outline-pill-button text-error"
            type="button"
            (click)="declineRequest()">
            <mat-icon svgIcon="close"></mat-icon>
            {{ "decline" | i18n }}
          </button>
          <button
            class="outline-pill-button text-secondary"
            type="button"
            (click)="acceptRequest()">
            <mat-icon svgIcon="check"></mat-icon>
            {{ "intrested" | i18n }}
          </button>
        </ng-container>
        <ng-template #responseTemplate>
          <div class="response-status">
            <ng-container [ngSwitch]="ownStatus$ | async">
              <ng-container *ngSwitchCase="EmploymentInviteeStatusEnum.OPEN">
                <ng-container
                  *ngIf="employment.status === EmploymentStatusEnum.CLOSED">
                  {{ "employmentHasBeenOccupied" | i18n }}
                </ng-container>
                <ng-container
                  *ngIf="employment.status !== EmploymentStatusEnum.CLOSED">
                  {{ "noResponseGiven" | i18n }}
                </ng-container>
                <button
                  class="outline-pill-button"
                  (click)="hideJob()"
                  type="button"
                  data-cy="hide-employment-button">
                  <span class="mat-fab__label">{{
                    ("hide" | i18n) || "ausblenden" | titlecase
                  }}</span>
                </button>
              </ng-container>
              <ng-container
                *ngSwitchCase="EmploymentInviteeStatusEnum.AVAILABLE">
                <ng-container *ngIf="selfInvitee$ | async as selfInvitee">
                  {{
                    "acceptedAt"
                      | i18n
                        : {
                            date:
                              selfInvitee?.updatedAt
                              | displayDate: "dd.MM.yyyy HH:mm",
                            distance: selfInvitee?.updatedAt | formatDistance
                          }
                  }}
                </ng-container>
              </ng-container>
              <ng-container
                *ngSwitchCase="EmploymentInviteeStatusEnum.UNAVAILABLE">
                <ng-container *ngIf="selfInvitee$ | async as selfInvitee">
                  {{
                    "declinedAt"
                      | i18n
                        : {
                            date:
                              selfInvitee?.updatedAt
                              | displayDate: "dd.MM.yyyy HH:mm",
                            distance: selfInvitee?.updatedAt | formatDistance
                          }
                  }}
                </ng-container>
              </ng-container>
              <ng-container
                *ngSwitchCase="EmploymentInviteeStatusEnum.DECLINED">
                <ng-container *ngIf="selfInvitee$ | async as selfInvitee">
                  {{
                    "wasDeclinedAt"
                      | i18n
                        : {
                            date:
                              selfInvitee?.updatedAt
                              | displayDate: "dd.MM.yyyy HH:mm",
                            distance: selfInvitee?.updatedAt | formatDistance
                          }
                  }}
                </ng-container>
              </ng-container>
              <ng-container
                *ngSwitchCase="EmploymentInviteeStatusEnum.CANCELLED">
                <ng-container *ngIf="selfInvitee$ | async as selfInvitee">
                  {{
                    "canceledAt"
                      | i18n
                        : {
                            date:
                              selfInvitee?.updatedAt
                              | displayDate: "dd.MM.yyyy HH:mm",
                            distance: selfInvitee?.updatedAt | formatDistance
                          }
                  }}
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="EmploymentInviteeStatusEnum.BOOKED">
                <ng-container *ngIf="selfInvitee$ | async as selfInvitee">
                  {{
                    "bookedAtWithDate"
                      | i18n
                        : {
                            date:
                              selfInvitee?.updatedAt
                              | displayDate: "dd.MM.yyyy HH:mm",
                            distance: selfInvitee?.updatedAt | formatDistance
                          }
                  }}
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
        <ng-container *ngIf="employment?.status === EmploymentStatusEnum.OPEN">
          <button
            *ngIf="
              (selfInvitee$ | async)?.status !==
              EmploymentInviteeStatusEnum.OPEN
            "
            class="outline-pill-button icon-only"
            type="button"
            [matMenuTriggerFor]="actionsMenu"
            [matTooltip]="
              ('moreOptions' | i18n) || 'weitere optionen' | titlecase
            "
            (click)="$event.stopPropagation()">
            <mat-icon svgIcon="menu-dot"></mat-icon>
          </button>
          <mat-menu
            #actionsMenu="matMenu"
            class="fixed-icon-mat-menu themed">
            <button
              *ngIf="
                (selfInvitee$ | async)?.status ===
                EmploymentInviteeStatusEnum.AVAILABLE
              "
              mat-menu-item
              type="button"
              data-cy="cancel-employment-button"
              (click)="declineRequest()"
              class="danger-icon">
              <mat-icon svgIcon="close"></mat-icon>
              {{ "decline" | i18n }}
            </button>
            <button
              *ngIf="
                (selfInvitee$ | async)?.status ===
                EmploymentInviteeStatusEnum.UNAVAILABLE
              "
              mat-menu-item
              type="button"
              data-cy="duplicate-employment-button"
              (click)="acceptRequest()"
              class="success-icon">
              <mat-icon svgIcon="check"></mat-icon>
              {{ "intrested" | i18n }}
            </button>
          </mat-menu>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
